import {
  NEW_HOME_SECTION_VIEWED_NAME_BANNER_CAROUSEL,
  NEW_HOME_SECTION_VIEWED_NAME_CATEGORY_CARDS,
  NEW_HOME_SECTION_VIEWED_NAME_COLLECTIONS,
  NEW_HOME_SECTION_VIEWED_NAME_PLP,
  NEW_HOME_SECTION_VIEWED_NAME_REELS,
} from '../presentation/analytics/homePageSectionViewed';

function getActiveSectionName(attributeName = 'data-analytics-section-name'): string {
  if (typeof document === 'undefined') return '';

  const sections = Array.from(document.querySelectorAll(`[${attributeName}]`));
  if (sections.length === 0) return '';

  const viewportCenter = window.innerHeight / 2;
  let activeSectionName = '';
  let minDistanceToCenter = Infinity;

  for (const section of sections) {
    const rect = section.getBoundingClientRect();
    if (rect.top <= viewportCenter && rect.bottom >= viewportCenter) {
      return section.getAttribute(attributeName) || '';
    }

    const sectionCenter = rect.top + rect.height / 2;
    const distance = Math.abs(sectionCenter - viewportCenter);
    if (distance < minDistanceToCenter) {
      minDistanceToCenter = distance;
      activeSectionName = section.getAttribute(attributeName) || '';
    }
  }

  return activeSectionName;
}

const HOME_SECTION_NAME_MAP: Readonly<Record<string, string>> = {
  'Shop By Category': NEW_HOME_SECTION_VIEWED_NAME_CATEGORY_CARDS,
  'Offers Carousel': NEW_HOME_SECTION_VIEWED_NAME_BANNER_CAROUSEL,
  'Handpicked for You': NEW_HOME_SECTION_VIEWED_NAME_COLLECTIONS,
  'Shop The Look': NEW_HOME_SECTION_VIEWED_NAME_REELS,
  'Recommended For You': NEW_HOME_SECTION_VIEWED_NAME_PLP,
};

export function getActiveHomeSectionName(): string {
  const sectionName = getActiveSectionName();
  return HOME_SECTION_NAME_MAP[sectionName] ?? sectionName;
}
